import { render, staticRenderFns } from "./RetrievalSettings.vue?vue&type=template&id=60b20519&"
import script from "./RetrievalSettings.vue?vue&type=script&lang=ts&"
export * from "./RetrievalSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports